export const resetReducer = reducerName => ({ type: reducerName.toUpperCase() });
